import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_ADAS_IDS](state, data) {
    state.ids = data
  },
  [types.SET_ADASINSPECTION](state, data) {
    state.adasInspection = data
  },
  [types.SET_ADAS_MATRICES](state, data) {
    state.adasmatrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrices = data
        console.log('Storing to Session', state.adasmatrices)
        storage.session.setItem(types.SESSION_ADAS_MATRIX, JSON.stringify(state.adasmatrices))
      }
    }
  },
  [types.SET_LINKS](state, data) {
    state.links = data
    try {
      if (data) {
        if (Array.isArray(data)) {
          data.forEach(element => {
            if (element.links) {
              if (element.links !== null) {
                try {
                  element.links = JSON.parse(element.links)
                } catch (e) {
                  element.links = []
                }
              }
            }
          })
        } else {
          state.links = data
          if (state.links.links) {
            if (state.links.links !== null) {
              try {
                state.links.links = JSON.parse(state.links.links)
              } catch (e) {
                state.links.links = []
              }
            }
          }
        }
      }
    } catch (e) {
      console.log('Error (adas > mutations > Set Links)', e)
    }
    console.log('Got Links', state.links)
  },
  [types.SET_LOOKUPS](state, [keys, lookups, showIsactive]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      if (lookups !== undefined && lookups !== null) {
        for (let lookup of lookups) {
          if (lookup.key === key) {
            lookup.name = lookup.value || lookup.name
            lookup.value = lookup.id
            lookup.isInactive = lookup.isInactive !== undefined ? lookup.isInactive : showIsactive
            _lookups[key].push(lookup)
          }
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
    console.log('Got ADAS Lookups', state.lookups)
  },
  [types.SET_REPAIRLINES](state, data) {
    state.repairlines = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.repairlines = data
      }
    }
    console.log('ADAS Repair Lines', state.repairlines)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/mutations.js